// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__33YEe","title":"Header_title__2V0JC","left":"Header_left__iLV3S","clinicName":"Header_clinicName__3pSct"};